<template v-once>
  <img src="@/assets/icons/mdedge_icon.png" alt="mdedge icon">
</template>

<script>
export default {
  name: "MDedge",
};
</script>

<style scoped>
</style>